import type { CustomFormAnswerPhoto } from "@/typings/customForm";
import { Photo, PhotoFile, PhotoThumb } from "@/typings/photo";

// PhotoViewerModal takes a Photo instance, and the §17 contract's answer photo
// is a plain object missing three of its fields (name, created_by_name,
// created_at). This is the seam that adapts one to the other.
//
// The two authorship fields stay empty rather than borrowing the answer's:
// the answer records who wrote it, not who took each photo, and the viewer's
// source line already reads truthfully from the photo's own `source`
// ("Tech App"). `name` only titles the modal, so the caller supplies the
// question it answers.
export function answerPhotoToPhoto(
  photo: CustomFormAnswerPhoto,
  name = ""
): Photo {
  return new Photo({
    id: photo.id,
    job_id: photo.job_id,
    name,
    file: new PhotoFile({
      url: photo.file.url,
      thumb: new PhotoThumb({ url: photo.file.thumb.url })
    }),
    download_url: photo.download_url,
    source: photo.source,
    customer_visible: photo.customer_visible,
    caption: photo.caption
  });
}
